<template>
  <table class="table b-t b-b white">
    <thead>
      <th>Date/Time</th>
      <th>User</th>
      <th>Activity</th>
    </thead>
    <tbody>
      <tr v-for="item in order.history" :key="item.id">
        <td>{{ calendar(item.created_at) }}</td>
        <td>{{ item.user.name }}</td>
        <td>{{ item.body }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import moment from 'moment'
export default {
  name: 'history-tab',
  props: {
    order: Object,
  },

  methods: {
    calendar(date) {
      return moment(date).calendar()
    }
  }
}
</script>